import React from 'react';
import ViewerErrorBoundary from '../../../common/ViewerConclusion/ViewerErrorBoundary';
import { QuestionText, StyledTextField } from '../../QuestionViewer.styles';
export const BLANK_QUESTION_TEXTFIELD_LABEL = 'fill in the blank answer';
const BlankQuestionViewer = ({ componentValues, setAnswer, answer, disabled }) => {
    const { question } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const onChange = (e) => {
        setAnswer(e.target.value);
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(QuestionText, null, question),
        React.createElement(StyledTextField, { id: "blankAnswer", name: "blankAnswer", variant: "outlined", fullWidth: true, value: answer !== null && answer !== void 0 ? answer : '', onChange: onChange, "data-testid": "blankAnswer-answer", inputProps: { 'aria-label': BLANK_QUESTION_TEXTFIELD_LABEL }, disabled: disabled })));
};
export default BlankQuestionViewer;
//# sourceMappingURL=index.js.map